import { useEffect, useState } from "react";
import DivStyle from "../../components/style/div.component";
import Table from "../../components/table/Table";
import ClubMemberTable from "../../components/table/ClubMemberTable";
import Page from "../../components/table/paging";
import { FormProps } from "../../components/form/interface/formInterface";
import InputFormStyle from "../../components/style/input_form.component";
import Icon from "@mdi/react";

import {
  mdiMagnify,
  mdiCalendar,
  mdiRefresh,
  mdiDownload,
  mdiFileExcel,
} from "@mdi/js";
import {
  exportClubListToExcel,
  exportDetailedClubDataToExcel,
  exportMemberListToExcel,
} from "./utils/excelExport";
import { IClub, IClubMember } from "./interface/interface";
import { useSetRecoilState } from "recoil";
import { loadingState } from "../../recoil/loading.atom";
import GAMEAPI from "../../api/game";
import SmallForm from "../../components/form/small_form";
import AdminAPI from "../../api/admin";
import {
  ICreateMemberClubReward,
  ICreateMemberClubRewardResponse,
} from "../../api/admin/club-reward";

const Club = () => {
  const [clubList, setClubList] = useState<IClub[]>([]);
  const [searchClubList, setSearchClubList] = useState<IClub[]>([]);
  const [clubId, setClubId] = useState(0);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [ownerUserId, setOwnerUserId] = useState(0);
  const [memberCount, setMemberCount] = useState(0);
  const [isOwner, setIsOwner] = useState(0);
  const [isJoined, setIsJoined] = useState(false);
  const [clubRank, setClubRank] = useState(0);
  const setIsLoading = useSetRecoilState(loadingState);

  // 날짜 선택 상태 추가
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // 추가 통계 필드들
  const [totalHandCount, setTotalHandCount] = useState<string | number>(0);
  const [totalRingWinAmount, setTotalRingWinAmount] = useState<string | number>(
    0
  );
  const [totalRingWinCount, setTotalRingWinCount] = useState<string | number>(
    0
  );
  const [totalTournamentWinCount, setTotalTournamentWinCount] = useState<
    string | number
  >(0);
  const [totalTournamentJoinCount, setTotalTournamentJoinCount] = useState<
    string | number
  >(0);
  const [totalBetAmount, setTotalBetAmount] = useState<string | number>(0);
  const [totalRakeAmount, setTotalRakeAmount] = useState<string | number>(0);
  const [topTotalHandCount, setTopTotalHandCount] = useState<string | number>(
    0
  );
  const [topTotalRingWinAmount, setTopTotalRingWinAmount] = useState<
    string | number
  >(0);
  const [topTotalRingWinCount, setTopTotalRingWinCount] = useState<
    string | number
  >(0);
  const [topTotalTournamentJoinCount, setTopTotalTournamentJoinCount] =
    useState<string | number>(0);
  const [topTotalTournamentWinCount, setTopTotalTournamentWinCount] = useState<
    string | number
  >(0);
  const [topTotalBetAmount, setTopTotalBetAmount] = useState<string | number>(
    0
  );
  const [topTotalRakeAmount, setTopTotalRakeAmount] = useState<string | number>(
    0
  );
  const [statsUpdatedAt, setStatsUpdatedAt] = useState("");

  const [selectedFile, setSelectedFile] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const [memberList, setMemberList] = useState<IClubMember[]>([]);
  const [memberListSearchList, setMemberListSearchList] = useState<
    IClubMember[]
  >([]);
  const [memberListSearch, setMemberListSearch] = useState("");
  const [memberListPage, setMemberListPage] = useState(1);
  const [memberListTotalPages, setMemberListTotalPages] = useState(0);

  const [mode, setMode] = useState("I");
  const [clubMode, setClubMode] = useState("CR");

  const [selectedMember, setSelectedMember] = useState<IClubMember | null>(
    null
  );

  // 멤버 테이블 정렬 상태 관리
  const [memberSortColumn, setMemberSortColumn] = useState<string>("");
  const [memberSortDirection, setMemberSortDirection] = useState<
    "asc" | "desc"
  >("asc");

  const [rewardFilter, setRewardFilter] = useState<"all" | "Y" | "N">("all");

  // 핸드 수 필터 상태 관리 (10개 이상만 보기)
  const [handCountFilter, setHandCountFilter] = useState<boolean>(false);

  const formClubMemberData: FormProps = {
    title: "클럽 회원",
    form: [
      {
        value: selectedMember?.nickname,
        setValue: setSelectedMember,
        label: "회원 닉네임",
        width: "100%",
        type: "input-dash",
        disabled: true,
      },
      {
        value: selectedMember?.isRewarded,
        setValue: () => {},
        label: "리워드 지급 여부",
        width: "100%",
        type: "input-dash",
      },
    ],
  };

  const formData: FormProps = {
    title: "클럽 상세 정보",
    form: [
      {
        value: name,
        setValue: setName,
        label: "클럽명",
        width: "100%",
        type: "input",
        disabled: true,
      },
      {
        value: description,
        setValue: setDescription,
        label: "클럽 설명",
        width: "100%",
        type: "input",
        disabled: true,
      },
      {
        value: ownerUserId,
        setValue: setOwnerUserId,
        label: "소유자 ID",
        width: "100%",
        type: "input",
        disabled: true,
      },
      {
        value: memberCount,
        setValue: setMemberCount,
        label: "멤버 수",
        width: "100%",
        type: "input",
        disabled: true,
      },
      {
        value: totalHandCount,
        setValue: setTotalHandCount,
        label: "총 핸드 수",
        width: "100%",
        type: "input",
      },
      {
        value: totalRingWinAmount,
        setValue: setTotalRingWinAmount,
        label: "총 링 상금",
        width: "100%",
        type: "input",
        disabled: true,
      },
      {
        value: totalRingWinCount,
        setValue: setTotalRingWinCount,
        label: "총 링 승리 횟수",
        width: "100%",
        type: "input",
        disabled: true,
      },
      {
        value: totalTournamentWinCount,
        setValue: setTotalTournamentWinCount,
        label: "토너먼트 승리 횟수",
        width: "100%",
        type: "input",
        disabled: true,
      },
      {
        value: totalTournamentJoinCount,
        setValue: setTotalTournamentJoinCount,
        label: "토너먼트 참가 횟수",
        width: "100%",
        type: "input",
        disabled: true,
      },
      {
        value: totalBetAmount,
        setValue: setTotalBetAmount,
        label: "총 베팅 금액",
        width: "100%",
        type: "input",
        disabled: true,
      },
      {
        value: totalRakeAmount,
        setValue: setTotalRakeAmount,
        label: "총 레이크 금액",
        width: "100%",
        type: "input",
        disabled: true,
      },
      {
        value: selectedFile,
        setValue: setSelectedFile,
        label: "클럽 이미지를 첨부해주세요.",
        width: "100%",
        type: "file",
      },
      {
        value: imageUrl,
        setValue: setImageUrl,
        label: "이미지",
        width: "100%",
        type: "image",
      },
      {
        value: statsUpdatedAt,
        setValue: setStatsUpdatedAt,
        label: "통계 업데이트",
        width: "100%",
        type: "date",
      },
    ],
  };

  const headers = [
    {
      text: "클럽 순위",
      align: "center",
      sortable: false,
      value: "clubRank",
    },
    {
      text: "클럽명",
      align: "center",
      sortable: false,
      value: "name",
    },
    {
      text: "멤버 수",
      align: "center",
      sortable: false,
      value: "memberCount",
    },
    {
      text: "가입 가능",
      align: "center",
      sortable: false,
      value: "canJoin",
    },
  ];

  const clubHeaders = [
    {
      text: "등급",
      align: "center",
      sortable: false,
      value: "role",
    },
    {
      text: "닉네임",
      align: "center",
      sortable: false,
      value: "nickname",
    },
    {
      text: "가입일",
      align: "center",
      sortable: true,
      value: "joinedAt",
    },
    {
      text: "핸드 수",
      align: "center",
      sortable: true,
      value: "handCount",
    },
    {
      text: "승리 금액",
      align: "center",
      sortable: true,
      value: "winAmount",
    },
    {
      text: "배팅 금액",
      align: "center",
      sortable: true,
      value: "betAmount",
    },
    {
      text: "승리 횟수",
      align: "center",
      sortable: true,
      value: "winCount",
    },
    {
      text: "토너먼트 참가 횟수",
      align: "center",
      sortable: true,
      value: "tournamentJoinCount",
    },
    {
      text: "리워드 지급 여부",
      align: "center",
      sortable: true,
      value: "isRewarded",
    },
  ];

  function formatDate(dateString: string) {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  // 현재 날짜를 YYYY-MM-DD 형식으로 반환
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // 일주일 전 날짜를 YYYY-MM-DD 형식으로 반환
  const getLastWeekDate = () => {
    const today = new Date();
    const lastWeek = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
    const year = lastWeek.getFullYear();
    const month = (lastWeek.getMonth() + 1).toString().padStart(2, "0");
    const day = lastWeek.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const deleteMember = async () => {
    if (!selectedMember) return;
    // 삭제 확인 대화상자
    const isConfirmed = window.confirm(
      `정말로 "${selectedMember.nickname}" 클럽원을 삭제하시겠습니까?`
    );

    if (!isConfirmed) {
      return; // 사용자가 취소하면 함수 종료
    }

    try {
      const response = await GAMEAPI.deleteMember(
        selectedMember.userId,
        clubId
      );
      if (response.data.result === 1) {
        alert("클럽원 삭제 성공");
        getClubMembers(clubId);
      } else {
        alert("클럽원 삭제 실패");
      }
    } catch (error) {
      console.error("클럽원 삭제 실패:", error);
    }
  };

  // 클럽 상세 정보 가져오기 (날짜 범위 포함)
  const getClubDetail = async (item: IClub) => {
    try {
      setIsLoading(true);
      const response = await GAMEAPI.getMyClub(
        item.clubId,
        startDate || undefined,
        endDate || undefined
      );
      console.log("클럽 상세 응답:", response.data);

      if (response.data.result === 1 && response.data.payload) {
        const clubData = response.data.payload;
        detail(clubData);
      } else {
        // API에서 상세 정보를 못 가져오면 기본 데이터 사용
        detail(item);
      }
    } catch (error) {
      console.error("클럽 상세 정보 로드 실패:", error);
      // 오류 시 기본 데이터 사용
      detail(item);
    } finally {
      setIsLoading(false);
    }
  };

  // 멤버의 리워드 지급 여부를 확인하는 함수
  const checkMemberRewardStatus = (
    member: IClubMember,
    rewardList: ICreateMemberClubRewardResponse[]
  ): string => {
    return rewardList.some((reward) => reward.userId === member.userId)
      ? "Y"
      : "N";
  };

  const handleSetMemberList = async (
    item: {
      members: IClubMember[];
      total: number;
    },
    clubId: number
  ) => {
    const response = await AdminAPI.getMemberClubReward(clubId);
    const memberList = item.members.map((member) => ({
      ...member,
      isRewarded: checkMemberRewardStatus(member, response),
    }));
    setMemberList(memberList);
    setMemberListSearchList(memberList);
    setMemberListTotalPages(Math.ceil(item.total / 10));
    setMemberListPage(1);

    // 필터들 초기화
    setRewardFilter("all");
    setHandCountFilter(false);
  };

  // 클럽 멤버 목록 가져오기 (날짜 범위 포함)
  const getClubMembers = async (clubId: number) => {
    try {
      const response = await GAMEAPI.getMemberList(
        clubId,
        startDate || undefined,
        endDate || undefined
      );
      if (response.data.result === 1 && response.data.payload) {
        handleSetMemberList(response.data.payload, clubId);
      }
    } catch (error) {
      console.error("클럽 멤버 로드 실패:", error);
    }
  };

  const detail = (item: IClub) => {
    setMode("U");
    setClubId(item.clubId);
    setName(item.name);
    setDescription(item.description);
    setImageUrl(item.imageUrl);
    setOwnerUserId(item.ownerUserId);
    setMemberCount(item.memberCount);
    setIsOwner(item.isOwner);
    setIsJoined(item.isJoined);
    setClubRank(item.clubRank);

    // 숫자 필드들에 콤마 형식 적용
    setTotalHandCount(item.totalHandCount?.toLocaleString() || "0");
    setTotalRingWinAmount(item.totalRingWinAmount?.toLocaleString() || "0");
    setTotalRingWinCount(item.totalRingWinCount?.toLocaleString() || "0");
    setTotalTournamentWinCount(
      item.totalTournamentWinCount?.toLocaleString() || "0"
    );
    setTotalTournamentJoinCount(
      item.totalTournamentJoinCount?.toLocaleString() || "0"
    );
    setTotalBetAmount(item.totalBetAmount?.toLocaleString() || "0");
    setTotalRakeAmount(item.totalRakeAmount?.toLocaleString() || "0");

    // Top 통계 필드들도 콤마 형식 적용
    setTopTotalHandCount(item.topTotalHandCount?.toLocaleString() || "0");
    setTopTotalRingWinAmount(
      item.topTotalRingWinAmount?.toLocaleString() || "0"
    );
    setTopTotalRingWinCount(item.topTotalRingWinCount?.toLocaleString() || "0");
    setTopTotalTournamentJoinCount(
      item.topTotalTournamentJoinCount?.toLocaleString() || "0"
    );
    setTopTotalTournamentWinCount(
      item.topTotalTournamentWinCount?.toLocaleString() || "0"
    );
    setTopTotalBetAmount(item.topTotalBetAmount?.toLocaleString() || "0");
    setTopTotalRakeAmount(item.topTotalRakeAmount?.toLocaleString() || "0");

    setStatsUpdatedAt(
      item.statsUpdatedAt ? formatDate(item.statsUpdatedAt) : ""
    );
    setSelectedFile(null);

    // 클럽을 선택했을 때 멤버 목록도 가져오기
    getClubMembers(item.clubId);
  };

  // 전체 클럽 데이터 한 번에 로드 (날짜 범위 포함)
  const getClubList = async () => {
    try {
      setIsLoading(true);
      // 큰 limit으로 전체 데이터 한 번에 가져오기
      const response = await GAMEAPI.getClubList(
        1,
        1000,
        startDate || undefined,
        endDate || undefined
      );
      console.log("클럽 목록 응답:", response.data);

      let clubData = [];

      if (response.data.result === 1 && response.data.payload) {
        // payload 구조 확인
        if (Array.isArray(response.data.payload)) {
          clubData = response.data.payload;
        } else if (response.data.payload.clubs) {
          clubData = response.data.payload.clubs;
        } else if (response.data.payload.list) {
          clubData = response.data.payload.list;
        } else {
          // payload 자체가 클럽 데이터인 경우
          clubData = [response.data.payload];
        }
      }

      const updatedData = clubData.map((item: IClub) => ({
        ...item,
        totalHandCount: item.totalHandCount?.toLocaleString() || "0",
        totalRingWinAmount: item.totalRingWinAmount?.toLocaleString() || "0",
        totalRingWinCount: item.totalRingWinCount?.toLocaleString() || "0",
        totalTournamentWinCount:
          item.totalTournamentWinCount?.toLocaleString() || "0",
        totalTournamentJoinCount:
          item.totalTournamentJoinCount?.toLocaleString() || "0",
        totalBetAmount: item.totalBetAmount?.toLocaleString() || "0",
        statsUpdatedAt: item.statsUpdatedAt
          ? formatDate(item.statsUpdatedAt)
          : "",
      }));

      // 전체 데이터를 상태에 저장
      setClubList(updatedData);
      setSearchClubList(updatedData);

      // 테이블 컴포넌트에서 페이징 처리하므로 totalPages 계산
      const totalPages = Math.ceil(updatedData.length / 10);
      setTotalPages(totalPages);

      console.log("처리된 클럽 데이터:", updatedData);
      console.log("총 클럽 수:", updatedData.length);
      console.log("총 페이지:", totalPages);
      if (clubId > 0) {
        const item = clubList.find((club) => club.clubId === clubId);
        if (item) getClubDetail(item);
      }
    } catch (error) {
      console.error("클럽 목록 로드 실패:", error);
      alert("클럽 목록을 불러올 수 없습니다.");
    } finally {
      setIsLoading(false);
    }
  };

  // 날짜 범위 초기화
  const resetDateRange = () => {
    setStartDate("");
    setEndDate("");
  };

  // 기본 날짜 범위 설정 (지난 일주일)
  const setDefaultDateRange = () => {
    setStartDate(getLastWeekDate());
    setEndDate(getCurrentDate());
  };

  useEffect(() => {
    // 컴포넌트 마운트 시 기본 날짜 범위 설정
    setDefaultDateRange();
  }, []);

  useEffect(() => {
    getClubList();
  }, [startDate, endDate]); // 날짜가 변경될 때마다 데이터 다시 로드

  // 엑셀 내보내기 함수들
  const handleExportBasic = () => {
    exportClubListToExcel(setIsLoading);
  };

  const handleExportMemberList = () => {
    exportMemberListToExcel(memberListSearchList);
  };

  const handleExportDetailed = () => {
    exportDetailedClubDataToExcel(setIsLoading);
  };

  const handleSearch = (search: string) => {
    setCurrentPage(1); // 검색 시 첫 페이지로

    if (!search.trim()) {
      // 검색어가 없으면 전체 목록 표시
      setSearchClubList(clubList);
      const totalPages = Math.ceil(clubList.length / 10);
      setTotalPages(totalPages);
      return;
    }

    // 전체 데이터에서 검색
    const filteredList = clubList.filter((item: IClub) => {
      return Object.values(item).some((value) => {
        if (value)
          return value.toString().toLowerCase().includes(search.toLowerCase());
      });
    });

    setSearchClubList(filteredList);
    const totalPages = Math.ceil(filteredList.length / 10);
    setTotalPages(totalPages);
  };

  const handleSearchMember = (search: string) => {
    setMemberListPage(1);
    if (!search.trim()) {
      setMemberListSearchList(memberList);
      return;
    }
    const filteredList = memberList.filter((item: IClubMember) => {
      return Object.values(item).some((value) => {
        if (value)
          return value.toString().toLowerCase().includes(search.toLowerCase());
      });
    });
    setMemberListSearchList(filteredList);
    const totalPages = Math.ceil(filteredList.length / 10);
    setMemberListTotalPages(totalPages);
  };

  const handleSetSelectedMember = (item: IClubMember) => {
    console.log(item);
    setSelectedMember(item);
  };

  const handleReward = async () => {
    if (!selectedMember) return;
    const request: ICreateMemberClubReward = {
      clubId,
      userIds: [selectedMember.userId],
    };
    const response = await AdminAPI.createMemberClubReward(request);
    if (response.code === 200) {
      alert(response.message);
      await getClubMembers(clubId);
    } else {
      alert(response.message);
    }
  };

  const handleCancelReward = async () => {
    if (!selectedMember) return;
    const response = await AdminAPI.deleteMemberClubReward(
      clubId,
      selectedMember.userId
    );
    if (response.code === 200) {
      alert(response.message);
      await getClubMembers(clubId);
    } else {
      alert(response.message);
    }
  };

  const handleSetClubRewards = async () => {
    if (!clubId || memberListSearchList.length === 0) return;
    const request: ICreateMemberClubReward = {
      clubId,
      userIds: memberListSearchList.map((member) => member.userId),
    };
    const response = await AdminAPI.createMemberClubReward(request);
    if (response.code === 200) {
      alert(response.message);
      await getClubMembers(clubId);
    } else {
      alert(response.message);
    }
  };

  // 멤버 목록 정렬 및 필터링 함수
  const handleMemberSort = (column: string) => {
    // 리워드 지급 여부는 필터링 처리
    if (column === "isRewarded") {
      handleRewardFilter();
      return;
    }

    // 일반 정렬 처리
    let direction: "asc" | "desc" = "asc";

    if (memberSortColumn === column && memberSortDirection === "asc") {
      direction = "desc";
    }

    setMemberSortColumn(column);
    setMemberSortDirection(direction);

    const sortedData = [...memberListSearchList].sort((a: any, b: any) => {
      let aValue = a[column];
      let bValue = b[column];

      // 숫자 값인 경우 처리
      if (typeof aValue === "number" && typeof bValue === "number") {
        return direction === "asc" ? aValue - bValue : bValue - aValue;
      }

      // 불린 값 처리
      if (typeof aValue === "boolean") {
        aValue = aValue ? 1 : 0;
      }
      if (typeof bValue === "boolean") {
        bValue = bValue ? 1 : 0;
      }

      // 문자열 값 처리
      if (typeof aValue === "string" && typeof bValue === "string") {
        return direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      if (aValue < bValue) {
        return direction === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return direction === "asc" ? 1 : -1;
      }
      return 0;
    });

    setMemberListSearchList(sortedData);
  };

  // 리워드 필터링 함수
  const handleRewardFilter = () => {
    let nextFilter: "all" | "Y" | "N";

    switch (rewardFilter) {
      case "all":
        nextFilter = "Y";
        break;
      case "Y":
        nextFilter = "N";
        break;
      case "N":
        nextFilter = "all";
        break;
      default:
        nextFilter = "all";
    }

    setRewardFilter(nextFilter);
    applyRewardFilter(nextFilter);
  };

  // 통합 필터 적용 함수
  const applyAllFilters = (
    rewardFilterValue?: "all" | "Y" | "N",
    handCountFilterValue?: boolean
  ) => {
    const currentRewardFilter =
      rewardFilterValue !== undefined ? rewardFilterValue : rewardFilter;
    const currentHandCountFilter =
      handCountFilterValue !== undefined
        ? handCountFilterValue
        : handCountFilter;

    let filteredData = memberList;

    // 리워드 필터 적용
    if (currentRewardFilter !== "all") {
      filteredData = filteredData.filter(
        (member) => member.isRewarded === currentRewardFilter
      );
    }

    // 핸드 수 필터 적용 (10개 이상만 보기)
    if (currentHandCountFilter) {
      filteredData = filteredData.filter(
        (member) => member.handCount && member.handCount >= 10
      );
    }

    setMemberListSearchList(filteredData);
    setMemberListTotalPages(Math.ceil(filteredData.length / 10));
    setMemberListPage(1); // 첫 페이지로 이동
  };

  // 리워드 필터 적용 함수 (기존 함수는 통합 함수 호출로 변경)
  const applyRewardFilter = (filter: "all" | "Y" | "N") => {
    applyAllFilters(filter);
  };

  // 핸드 수 필터 적용 함수
  const handleHandCountFilterChange = (checked: boolean) => {
    setHandCountFilter(checked);
    applyAllFilters(undefined, checked);
  };

  return (
    <DivStyle
      style={{ overflow: "auto" }}
      backgroundColor="#121212"
      height="100vh"
      display="flex"
      flex_direction="row"
      marginTop="65px"
      setMobile={true}
    >
      <DivStyle
        width="66%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileTable={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>
          클럽 관리
        </h2>

        {/* 날짜 선택 영역 */}
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="20px"
          padding="20px"
        >
          <div
            style={{
              color: "white",
              marginBottom: "15px",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            <Icon
              path={mdiCalendar}
              size={0.8}
              style={{ marginRight: "8px" }}
            />
            조회 기간 설정
          </div>
          <DivStyle
            display="flex"
            flex_direction="row"
            align_items="center"
            justify_content="space-between"
            gap="15px"
          >
            <DivStyle
              display="flex"
              flex_direction="row"
              align_items="center"
              gap="10px"
            >
              <label style={{ color: "white", minWidth: "60px" }}>
                시작일:
              </label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                style={{
                  padding: "8px",
                  borderRadius: "5px",
                  border: "1px solid #444",
                  backgroundColor: "#2A2A2A",
                  color: "white",
                }}
              />
            </DivStyle>
            <DivStyle
              display="flex"
              flex_direction="row"
              align_items="center"
              gap="10px"
            >
              <label style={{ color: "white", minWidth: "60px" }}>
                종료일:
              </label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                style={{
                  padding: "8px",
                  borderRadius: "5px",
                  border: "1px solid #444",
                  backgroundColor: "#2A2A2A",
                  color: "white",
                }}
              />
            </DivStyle>
            <DivStyle display="flex" flex_direction="row" gap="10px">
              <button
                onClick={setDefaultDateRange}
                style={{
                  padding: "8px 12px",
                  borderRadius: "5px",
                  border: "1px solid #666",
                  backgroundColor: "#4A4A4A",
                  color: "white",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
                onMouseOver={(e) =>
                  ((e.target as HTMLElement).style.backgroundColor = "#5A5A5A")
                }
                onMouseOut={(e) =>
                  ((e.target as HTMLElement).style.backgroundColor = "#4A4A4A")
                }
              >
                지난 일주일
              </button>
              <button
                onClick={resetDateRange}
                style={{
                  padding: "8px 12px",
                  borderRadius: "5px",
                  border: "1px solid #666",
                  backgroundColor: "#666",
                  color: "white",
                  cursor: "pointer",
                  fontSize: "12px",
                }}
                onMouseOver={(e) =>
                  ((e.target as HTMLElement).style.backgroundColor = "#777")
                }
                onMouseOut={(e) =>
                  ((e.target as HTMLElement).style.backgroundColor = "#666")
                }
              >
                <Icon
                  path={mdiRefresh}
                  size={0.6}
                  style={{ marginRight: "4px" }}
                />
                전체
              </button>
            </DivStyle>
          </DivStyle>
        </DivStyle>

        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="20px"
          marginBottom="10px"
        >
          <DivStyle
            width="100%"
            display="flex"
            flex_direction="row"
            justify_content="space-between"
            align_items="center"
            padding="20px"
          >
            <div style={{ color: "white" }}>
              총 {searchClubList.length.toLocaleString()}개 클럽
              {(startDate || endDate) && (
                <span
                  style={{
                    fontSize: "12px",
                    color: "#AAA",
                    marginLeft: "10px",
                  }}
                >
                  ({startDate || "시작일 없음"} ~ {endDate || "종료일 없음"})
                </span>
              )}
            </div>
            <DivStyle
              display="flex"
              flex_direction="row"
              align_items="center"
              gap="15px"
            >
              {/* 엑셀 내보내기 버튼들 */}
              <DivStyle display="flex" flex_direction="row" gap="10px">
                <button
                  onClick={handleExportBasic}
                  style={{
                    padding: "8px 12px",
                    borderRadius: "5px",
                    border: "1px solid #4CAF50",
                    backgroundColor: "#4CAF50",
                    color: "white",
                    cursor: "pointer",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                  onMouseOver={(e) =>
                    ((e.target as HTMLElement).style.backgroundColor =
                      "#45a049")
                  }
                  onMouseOut={(e) =>
                    ((e.target as HTMLElement).style.backgroundColor =
                      "#4CAF50")
                  }
                >
                  <Icon path={mdiFileExcel} size={0.6} />
                  기본 엑셀
                </button>
              </DivStyle>

              {/* 검색창 */}
              <DivStyle
                display="flex"
                flex_direction="row"
                align_items="center"
              >
                <InputFormStyle
                  onChange={(e) => handleSearch(e.target.value)}
                  placeholder="클럽 검색..."
                ></InputFormStyle>
                <Icon path={mdiMagnify} size={1} style={{ color: "white" }} />
              </DivStyle>
            </DivStyle>
          </DivStyle>
          <Table
            headers={headers}
            currentPage={currentPage}
            dataList={searchClubList}
            setDetail={getClubDetail}
          />
          <Page
            currentPage={currentPage}
            totalPages={totalPages}
            dataList={searchClubList}
            setCurrentPage={setCurrentPage}
          />
        </DivStyle>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="20px"
          marginBottom="10px"
        >
          <DivStyle
            width="100%"
            display="flex"
            flex_direction="row"
            justify_content="space-between"
            align_items="center"
            padding="20px"
          >
            <div style={{ color: "white" }}>
              총 {memberList.length.toLocaleString()}명
              {(startDate || endDate) && (
                <span
                  style={{
                    fontSize: "12px",
                    color: "#AAA",
                    marginLeft: "10px",
                  }}
                >
                  ({startDate || "시작일 없음"} ~ {endDate || "종료일 없음"})
                </span>
              )}
            </div>
            <DivStyle
              display="flex"
              flex_direction="row"
              align_items="center"
              gap="15px"
            >
              {/* 엑셀 내보내기 버튼들 */}
              <DivStyle display="flex" flex_direction="row" gap="10px">
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "white",
                    fontSize: "12px",
                    cursor: "pointer",
                    userSelect: "none",
                    marginRight: "15px",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={handCountFilter}
                    onChange={(e) =>
                      handleHandCountFilterChange(e.target.checked)
                    }
                    style={{
                      marginRight: "5px",
                    }}
                  />
                  핸드 수 10개 이상만 보기
                </label>
                <button
                  onClick={handleSetClubRewards}
                  style={{
                    padding: "8px 12px",
                    borderRadius: "5px",
                    border: "1px solid rgb(34, 85, 196)",
                    backgroundColor: "rgb(34, 85, 196)",
                    color: "white",
                    cursor: "pointer",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  리워드 전체 지급
                </button>
                <button
                  onClick={handleExportMemberList}
                  style={{
                    padding: "8px 12px",
                    borderRadius: "5px",
                    border: "1px solid #4CAF50",
                    backgroundColor: "#4CAF50",
                    color: "white",
                    cursor: "pointer",
                    fontSize: "12px",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                  onMouseOver={(e) =>
                    ((e.target as HTMLElement).style.backgroundColor =
                      "#45a049")
                  }
                  onMouseOut={(e) =>
                    ((e.target as HTMLElement).style.backgroundColor =
                      "#4CAF50")
                  }
                >
                  <Icon path={mdiFileExcel} size={0.6} />
                  기본 엑셀
                </button>
              </DivStyle>

              {/* 검색창 */}
              <DivStyle
                display="flex"
                flex_direction="row"
                align_items="center"
              >
                <InputFormStyle
                  onChange={(e) => handleSearchMember(e.target.value)}
                  placeholder="클럽원 검색..."
                ></InputFormStyle>
                <Icon path={mdiMagnify} size={1} style={{ color: "white" }} />
              </DivStyle>
            </DivStyle>
          </DivStyle>
          <ClubMemberTable
            headers={clubHeaders}
            currentPage={memberListPage}
            dataList={memberListSearchList}
            setDetail={handleSetSelectedMember}
            sortColumn={memberSortColumn}
            sortDirection={memberSortDirection}
            onSort={handleMemberSort}
            rewardFilter={rewardFilter}
          />
          <Page
            currentPage={memberListPage}
            totalPages={memberListTotalPages}
            dataList={memberListSearchList}
            setCurrentPage={setMemberListPage}
          />
        </DivStyle>
      </DivStyle>
      <DivStyle
        width="33%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileForm={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>
          클럽 정보
        </h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <SmallForm form={formData.form} title={formData.title} mode={mode} />
        </DivStyle>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <SmallForm
            form={formClubMemberData.form}
            title={formClubMemberData.title}
            mode={clubMode}
            save={handleReward}
            remove={deleteMember}
            cancel={handleCancelReward}
          />
        </DivStyle>
      </DivStyle>
    </DivStyle>
  );
};

export default Club;
